import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface ConfettiCelebrationProps {
  trigger: boolean;
  message?: string;
}
export function ConfettiCelebration({
  trigger,
  message
}: ConfettiCelebrationProps) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (trigger) {
      setShow(true);
      const timer = setTimeout(() => setShow(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [trigger]);
  if (!show) return null;
  return <AnimatePresence data-id="element-1550">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 pointer-events-none z-50 flex items-center justify-center" data-id="element-1551">

        {/* Confetti particles */}
        <div className="absolute inset-0 overflow-hidden" data-id="element-1552">
          {[...Array(40)].map((_, i) => <motion.div key={i} className="absolute w-3 h-3 rounded-full shadow-sm" style={{
          background: ['#fbbf24', '#f59e0b', '#4f46e5', '#10b981', '#fb7185', '#38bdf8' // sky
          ][i % 6],
          left: `${Math.random() * 100}%`,
          top: '-10%'
        }} initial={{
          y: 0,
          opacity: 1,
          rotate: 0,
          scale: 0.5
        }} animate={{
          y: window.innerHeight + 100,
          opacity: 0,
          rotate: 720,
          scale: 1,
          x: [0, (Math.random() - 0.5) * 300],
          transition: {
            duration: 2 + Math.random() * 2,
            delay: Math.random() * 0.5,
            ease: 'easeOut'
          }
        }} data-id="element-1553" />)}
        </div>

        {/* Message */}
        {message && <motion.div initial={{
        scale: 0,
        rotate: -10,
        y: 50
      }} animate={{
        scale: 1,
        rotate: 0,
        y: 0
      }} exit={{
        scale: 0,
        rotate: 10,
        y: -50
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 20
      }} className="bg-white rounded-[2rem] shadow-2xl p-8 max-w-md pointer-events-auto border-4 border-white relative z-10" data-id="element-1554">

            <div className="text-center" data-id="element-1555">
              <motion.div animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 10, -10, 0]
          }} transition={{
            duration: 0.6,
            repeat: 3
          }} className="text-7xl mb-4 drop-shadow-md" data-id="element-1556">

                🎉
              </motion.div>
              <h3 className="text-3xl font-black text-slate-900 mb-2 tracking-tight" data-id="element-1557">
                {message}
              </h3>
            </div>
          </motion.div>}
      </motion.div>
    </AnimatePresence>;
}